import Body from '../../components/Body';
import Posts from '../../components/Stories';
import Gallery from '../../components/Gallery';
import Generate from '../../components/GenerateImage';
import Valentine from '../../components/Valentine';
import React from 'react';
import NewsletterSignup from '../../components/NewsletterSignup';

export default function ImagesPage({ incrementGenerationCount }) {
  return (
    <Body>
      <Generate incrementGenerationCount={incrementGenerationCount} />
      <NewsletterSignup/>
      <Gallery />
    </Body>
  );
}